const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      if (input.__colorSwatchBound) return;
      input.__colorSwatchBound = true;
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          fetch(window.Shopify.routes.root + `products/${handleProduct}.js`)
            .then(response => response.json())
            .then(product => {
              const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

              if (variant) {
                const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);

                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove('media--second');
                      secondaryImage.classList.add('media--first');
                      flag = true;
                    }
                  }
                  if (flag == false) {
                    primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                    setTimeout(function(){
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                      if (secondaryImage) {
                        secondaryImage.remove();
                      }
                    }, 200);
                  }
                }
              }
            })
            .catch(() => {});
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

var hoverGalleryImageRequests = Object.create(null);

function resizeHoverGalleryImageUrl(src) {
  try {
    var url = new URL(src, window.location.origin);
    url.searchParams.set('width', '800');
    return url.toString();
  } catch (error) {
    return src;
  }
}

function getHoverGalleryImages(handle) {
  if (hoverGalleryImageRequests[handle]) return hoverGalleryImageRequests[handle];

  var productUrl = window.Shopify.routes.root + 'products/' + encodeURIComponent(handle) + '.js';
  hoverGalleryImageRequests[handle] = fetch(productUrl, { credentials: 'same-origin' })
    .then(function(response) {
      if (!response.ok) throw new Error('Unable to load product gallery');
      return response.json();
    })
    .then(function(product) {
      var urls = [];
      var seen = Object.create(null);
      var media = Array.isArray(product.media) ? product.media : [];

      media.forEach(function(item) {
        if (item.media_type && item.media_type !== 'image') return;
        var src = item.preview_image && item.preview_image.src ? item.preview_image.src : item.src;
        if (!src || seen[src]) return;
        seen[src] = true;
        urls.push(resizeHoverGalleryImageUrl(src));
      });

      if (urls.length === 0 && Array.isArray(product.images)) {
        product.images.forEach(function(item) {
          var src = typeof item === 'string' ? item : item.src;
          if (!src || seen[src]) return;
          seen[src] = true;
          urls.push(resizeHoverGalleryImageUrl(src));
        });
      }

      return urls;
    })
    .catch(function(error) {
      delete hoverGalleryImageRequests[handle];
      throw error;
    });

  return hoverGalleryImageRequests[handle];
}

// Hover Gallery - load every product image on demand through the arrow controls
function initHoverGallery() {
  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  document.querySelectorAll('.media.hover-gallery[data-hover-image-count], .media.hover-gallery[data-hover-images]').forEach(function(mediaEl) {
    if (mediaEl.__hoverGalleryInit) return;
    mediaEl.__hoverGalleryInit = true;

    var cardWrapper = mediaEl.closest('.card-wrapper');
    if (!cardWrapper) return;

    var imageCount = parseInt(mediaEl.dataset.hoverImageCount, 10) || 0;
    if (imageCount <= 1 && mediaEl.dataset.hoverImages) {
      try {
        imageCount = JSON.parse(mediaEl.dataset.hoverImages).length;
      } catch (error) {
        imageCount = 0;
      }
    }
    if (imageCount <= 1) return;

    var productHandle = cardWrapper.dataset.product;
    if (!productHandle) return;

    var images = null;
    var currentIndex = 0;
    var overlayImg = null;
    var dotsContainer = null;
    var prevBtn = null;
    var nextBtn = null;
    var loader = null;
    var imageLoadToken = 0;
    var isHovered = false;

    function isRevealReady() {
      var revealCard = mediaEl.closest('.collection-product-card, .product-recommendations__product, .product-recommendations__list .swiper-slide');
      if (!revealCard) return true;
      if (revealCard.hasAttribute('data-reveal') && !revealCard.classList.contains('is-visible')) return false;
      return !revealCard.matches(':not(.is-visible)[data-reveal]');
    }

    function ensureImages() {
      if (images) return Promise.resolve(images);

      return getHoverGalleryImages(productHandle).then(function(loadedImages) {
        images = loadedImages;
        if (images.length > 1 && images.length !== imageCount) {
          imageCount = images.length;
          renderIndicators();
        }
        return images;
      });
    }

    function setLoading(isLoading) {
      if (!loader) return;
      loader.classList.toggle('hover-gallery__loader--visible', isLoading);
      if (isLoading) {
        mediaEl.setAttribute('aria-busy', 'true');
      } else {
        mediaEl.removeAttribute('aria-busy');
      }
    }

    function renderIndicators() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      dotsContainer.classList.toggle('hover-gallery__dots--counter', imageCount > 8);

      if (imageCount > 8) {
        dotsContainer.textContent = (currentIndex + 1) + ' / ' + imageCount;
        return;
      }

      for (var i = 0; i < imageCount; i++) {
        var dot = document.createElement('span');
        dot.className = 'hover-gallery__dot';
        if (i === currentIndex) dot.classList.add('hover-gallery__dot--active');
        dotsContainer.appendChild(dot);
      }
    }

    function createElements() {
      if (overlayImg) return;

      overlayImg = document.createElement('img');
      overlayImg.className = 'hover-gallery__overlay';
      overlayImg.setAttribute('aria-hidden', 'true');
      overlayImg.alt = '';
      mediaEl.appendChild(overlayImg);

      dotsContainer = document.createElement('div');
      dotsContainer.className = 'hover-gallery__dots';
      dotsContainer.setAttribute('aria-hidden', 'true');
      renderIndicators();
      mediaEl.appendChild(dotsContainer);

      loader = document.createElement('span');
      loader.className = 'hover-gallery__loader';
      loader.setAttribute('aria-hidden', 'true');
      mediaEl.appendChild(loader);

      prevBtn = document.createElement('button');
      prevBtn.className = 'hover-gallery__arrow hover-gallery__arrow--prev';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.type = 'button';
      mediaEl.appendChild(prevBtn);

      nextBtn = document.createElement('button');
      nextBtn.className = 'hover-gallery__arrow hover-gallery__arrow--next';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.type = 'button';
      mediaEl.appendChild(nextBtn);

      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = (currentIndex - 1 + imageCount) % imageCount;
        goTo(idx);
      });

      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = (currentIndex + 1) % imageCount;
        goTo(idx);
      });
    }

    function goTo(index) {
      var previousIndex = currentIndex;
      var requestedIndex = ((index % imageCount) + imageCount) % imageCount;
      var requestToken = ++imageLoadToken;

      currentIndex = requestedIndex;
      updateIndicators(currentIndex);

      if (requestedIndex === 0) {
        setLoading(false);
        overlayImg.classList.remove('hover-gallery__overlay--visible');
        return;
      }

      setLoading(true);
      ensureImages()
        .then(function(loadedImages) {
          if (requestToken !== imageLoadToken || !isHovered) return;
          if (!loadedImages || loadedImages.length <= 1) throw new Error('Product gallery is unavailable');

          var actualIndex = requestedIndex % loadedImages.length;
          currentIndex = actualIndex;
          updateIndicators(currentIndex);

          var nextImage = new Image();
          nextImage.decoding = 'async';
          nextImage.onload = function() {
            if (requestToken !== imageLoadToken || !isHovered) return;
            overlayImg.src = loadedImages[actualIndex];
            overlayImg.classList.add('hover-gallery__overlay--visible');
            setLoading(false);
          };
          nextImage.onerror = function() {
            if (requestToken !== imageLoadToken) return;
            currentIndex = previousIndex;
            updateIndicators(currentIndex);
            setLoading(false);
          };
          nextImage.src = loadedImages[actualIndex];
        })
        .catch(function() {
          if (requestToken !== imageLoadToken) return;
          currentIndex = previousIndex;
          updateIndicators(currentIndex);
          setLoading(false);
        });
    }

    function updateIndicators(index) {
      if (!dotsContainer) return;
      if (dotsContainer.classList.contains('hover-gallery__dots--counter')) {
        dotsContainer.textContent = (index + 1) + ' / ' + imageCount;
        return;
      }

      var dots = dotsContainer.querySelectorAll('.hover-gallery__dot');
      for (var i = 0; i < dots.length; i++) {
        if (i === index) {
          dots[i].classList.add('hover-gallery__dot--active');
        } else {
          dots[i].classList.remove('hover-gallery__dot--active');
        }
      }
    }

    cardWrapper.addEventListener('mouseenter', function() {
      if (!DESKTOP_MQ.matches) return;
      if (!isRevealReady()) return;

      isHovered = true;
      createElements();
      dotsContainer.classList.add('hover-gallery__dots--visible');
      if (prevBtn) prevBtn.classList.add('hover-gallery__arrow--visible');
      if (nextBtn) nextBtn.classList.add('hover-gallery__arrow--visible');
      updateIndicators(currentIndex);

      // Fetch only the lightweight product metadata on hover. Image bytes load on arrow click.
      ensureImages().catch(function() {});
    });

    cardWrapper.addEventListener('mouseleave', function() {
      isHovered = false;
      imageLoadToken += 1;
      setLoading(false);

      if (overlayImg) {
        overlayImg.classList.remove('hover-gallery__overlay--visible');
      }
      if (dotsContainer) {
        dotsContainer.classList.remove('hover-gallery__dots--visible');
      }
      if (prevBtn) prevBtn.classList.remove('hover-gallery__arrow--visible');
      if (nextBtn) nextBtn.classList.remove('hover-gallery__arrow--visible');

      currentIndex = 0;
      updateIndicators(0);
    });
  });
}

function hoverGallery() {
  initHoverGallery();
  document.addEventListener('shopify:section:load', function() {
    initHoverGallery();
  });
}

// 초기화
(function () {
  colorSwatches();
  hoverGallery();
})()
